<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13YSWS5/tc-custom/9781118429242.jpg?1734286301430" alt="This image is the cover for the book Seven Years to Seven Figures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seven Years to Seven Figures
      </h1>
      <p class="bookDescription body article font2">
        <b>The secrets to accumulating wealth and rapidly increasing your net worth: “When Michael Masterson gives advice, I pay attention, and you should too.” —John Mauldin, bestselling author of <i>Eavesdropping on Millionaires</i></b><br/>  <br/> In <i>Seven Years to Seven Figures</i>, self-made multimillionaire and renowned wealth coach Michael Masterson reveals the steps you can take to accumulate seven-figure wealth within seven years or less. <i>Seven Years to Seven Figures</i> will give you the tools to:  increase your income  get the highest possible returns on investments  create a second stream of income  determine which of the four levels of wealth to aim for  dramatically increase your net worth with real estate investing  save wisely  secure your financial future faster than you may have ever dreamed 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Masterson
      </h2>
      
      <p class="authorDescription body article">MICHAEL MASTERSON has developed a loyal following through his writings in Early to Rise (www.earlytorise.com), an e-newsletter published by Agora, Inc. that mentors more than 160,000 success-oriented individuals to help them achieve their financial goals. Masterson has been making money for himself and others for almost four decades. At one time or another, he's owned and run multi-million dollar companies that were public/private, onshore/overseas, local/international, service-/product-oriented, retail/wholesale/direct mail, and even profit/not-for-profit. Masterson is the author of the Wall Street Journal bestsellers Automatic Wealth: The Six Steps to Financial Independence; Automatic Wealth for Grads . . . and Anyone Else Just Starting Out; Power and Persuasion: How to Command Success in Business and Your Personal Life (all published by Wiley); and Confessions of a Self-Made Millionaire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      John Wiley & Sons
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?698ab686